export default class GetQueryData {
	constructor() {
		this.data = {}; // 空のオブジェクトを用意
		// URLのクエリパラメータを取得して、dataオブジェクトに格納
		new URL(window.location).searchParams.forEach((value, key) => {
			this.data[key] = value; // dataオブジェクトに格納
		});
	}

	// dataオブジェクトを返すメソッド
	getData() {
		return this.data; // dataオブジェクトを返す
	}
}